<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        header="Upload Layout"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-6"
        modal >
        <form @submit.prevent="onSubmit(form)">
            <div class="w-full">
                <div class="field mt-4">
                    <FloatLabel>
                        <Select v-model="form.layout_id" :options="layoutOpt" optionLabel="descricao" optionValue="id" class="w-full" />
                        <label>Layout<span class="text-red-500">*</span></label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['layout_id'] }}</div>
                </div>

                <template v-if="showDataFields(form)" >
                    <div class="field mt-4">
                        <FloatLabel>
                            <Select v-model="form.solicitante_id" :options="solicitanteOpt" optionLabel="descricao" optionValue="id" class="w-full" />
                            <label>Solicitante<span class="text-red-500">*</span></label>
                        </FloatLabel>
                        <div class="text-xs text-red-500">{{ errors['solicitante_id'] }}</div>
                    </div>

                    <div class="field mt-4">
                        <InputGroup>
                            <FloatLabel>
                                <InputText id="cliente_id" v-model="form.cliente" class="w-full" readonly />
                                <label for="cliente_id">Cliente<span class="text-red-500">*</span></label>
                            </FloatLabel>
                            <Button icon="pi pi-search" severity="info" @click="visibleClienteListaSelect = true"></Button>
                            <Button icon="pi pi-times" severity="danger" @click="clearCliente"></Button>
                        </InputGroup>
                        <div class="text-xs text-red-500">{{ errors['cliente_id'] }}</div>
                    </div>
                </template>

                <!-- Upload de Arquivo -->
                <Fieldset legend="Upload de Arquivo">
                    <!-- Toolbar com Botão -->
                    
                    <BlockUI :blocked="isLoading" class="relative w-full px">
                        <Toolbar>
                            <template #end>
                                <div class="flex gap-1">
                                    <Button 
                                        label="Selecionar Arquivo"
                                        icon="pi pi-folder-open"
                                        severity="primary"
                                        @click="openFileDialog"
                                    />
                                    <Button
                                        label="Enviar"
                                        icon="pi pi-upload"
                                        severity="success"
                                        :loading="isLoadingFile"
                                        @click="handleUpload"
                                    />
                                    <Button 
                                        label="Limpar"
                                        icon="pi pi-trash"
                                        severity="danger"
                                        @click="clearFileDialog"
                                    />
                                </div>
                            </template>
                        </Toolbar>

                        <div class="field mt-4">
                            <FilePond
                                ref="pond"
                                name="arquivo"
                                labelIdle='Arraste o arquivo ou <span class="filepond--label-action">clique aqui</span>'
                                :files="files"
                                @updatefiles="onFileUpdate"
                                :instantUpload="false"
                            />
                        </div>

                        <div v-if="isLoading" class="absolute" style="top: calc(50% - 20px); left: calc(50% - 20px);">
                            <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                            <!-- <i class="pi pi-spinner pi-spin text-4xl text-blue-100"></i> -->
                        </div>
                    </BlockUI>
                </Fieldset>
            </div>

            <div class="w-full">
                <Toolbar class="mb-2 bg-gray-100">
                    <template #end>
                        <div class="flex items-center gap-1">
                            <Button icon="pi pi-search" label="Buscar" severity="sucess" size="small" @click="toggleBusca" />
                            <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small" @click="loadData" />
                        </div>
                    </template>
                </Toolbar>

                <DataTable :value="lista" :loading="isLoading" size="small" stripedRows showGridlines scrollable
                    scrollHeight="calc(100vh - 300px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
                    v-model:expandedRows="expandedRows"
                    @sort="onTableSort">

                    <Column expander style="width: 50px" />
                    <Column style="width: 100px" field="id" header="#" sortable></Column>
                    <Column field="layout" header="Layout" sortable></Column>
                    <Column field="arquivo" header="Arquivo" sortable></Column>
                    <Column field="created_at" header="Data/Hora" sortable>
                        <template #body="{ data }">
                            {{ dateFormat(data.created_at) }}
                        </template>
                    </Column>

                    <Column style="width: 80px" bodyClass="flex justify-content-end gap-1">
                        <template #body="{ data }">
                            <i v-if="data.status == STATUS.PENDENTE" class="flex pi pi-spin pi-spinner-dotted text-orange-500  align-items-center"></i>
                            <i v-if="data.status == STATUS.PROCESSANDO" class="flex pi pi-spin pi-spinner-dotted text-orange-500 align-items-center"></i>
                            <i v-if="data.status == STATUS.PRONTO" class="flex pi pi-circle-fill text-green-500 align-items-center"></i>
                            <i v-if="data.status == STATUS.ERRO" class="flex pi pi-circle-fill text-red-500 align-items-center"></i>
                            <Button icon="pi pi-trash" title="Remover" severity="danger"
                                size="small" @click="remove(data)" />
                        </template>
                    </Column>

                    <template #expansion="slotProps">
                        <div class="text-block p-2">
                            <template v-if="slotProps.data.erros" >
                                {{ slotProps.data.erros }}
                            </template>
                            <template v-else>
                                Sem erros ...
                            </template>
                        </div>
                    </template>

                    <template #empty>
                        <div class="text-center text-gray-600">
                            Nenhum registro encontrado
                        </div>
                    </template>
                </DataTable>

                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center">
                        <div class="flex justify-end mt-2 text-sm text-gray-600">
                            <span>{{ pagination.total }} registros</span>
                        </div>

                    </div>
                    <div class="flex align-items-center justify-content-center">
                        <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                            @page="onPage">
                        </Paginator>
                    </div>
                    <div class="flex align-items-center justify-content-center">
                    </div>
                </div>

                <Popover ref="busca" :closeOnEscape="false" :dismissable="false" class="w-3">
                    <div class="w-full">
                        <form @submit.prevent="onSubmitBusca">
                            <div class="w-full">
                                <div class="field mt-4">
                                    <FloatLabel>
                                        <InputText v-model="params.filter['pro.nome']" class="w-full" />
                                        <label>Provedor</label>
                                    </FloatLabel>
                                </div>
                                <div class="field mt-4">
                                    <FloatLabel>
                                        <InputText v-model="params.filter['cot.valor']" class="w-full" />
                                        <label>Valor</label>
                                    </FloatLabel>
                                </div>
                                <div class="field mt-4">
                                    <FloatLabel>
                                        <InputText v-model="params.filter['cot.tipo_link']" class="w-full" />
                                        <label>Tipo de Link</label>
                                    </FloatLabel>
                                </div>
                                <div class="field mt-4">
                                    <FloatLabel>
                                        <InputText v-model="params.filter['cot.velocidade']" class="w-full" />
                                        <label>Velocidade</label>
                                    </FloatLabel>
                                </div>
                                <div class="field mt-4">
                                    <FloatLabel>
                                        <Select id="ativo" v-model="params.filter['cot.aprovado']" :options="statusOptions"
                                            optionLabel="label" optionValue="value" :showClear="true" class="w-full" />
                                        <label for="ativo">Status</label>
                                    </FloatLabel>
                                </div>
                            </div>

                            <div class="flex justify-content-end gap-1">
                                <Button type="submit" label="Buscar" severity="success" icon="pi pi-search"
                                    class="flex align-items-center justify-content-center" />
                                <Button icon="pi pi-eraser" label="Limpar" severity="warn" size="small"
                                    class="flex align-items-center justify-content-center" @click="onClearBusca" />
                                <Button icon="pi pi-times" label="Fechar" severity="danger" size="small"
                                    class="flex align-items-center justify-content-center" @click="toggleBusca" />
                            </div>
                        </form>
                    </div>
                </Popover>
            </div>

            <div class="flex justify-content-end gap-1">
                <Button
                    label="Fechar"
                    severity="warn"
                    icon="pi pi-times"
                    size="small"
                    @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center"
                    :loading="isLoading" />
            </div>
        </form>
        <ClienteListaSelect :visible="visibleClienteListaSelect" :permissoes="permissoes" @close="visibleClienteListaSelect = false" @select="selectCliente" />
    </Dialog>
</template>
<script>
import vueFilePond from 'vue-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import Fieldset from 'primevue/fieldset';
import BlockUI from 'primevue/blockui';
import ProgressSpinner from 'primevue/progressspinner';

import 'filepond/dist/filepond.min.css'

const FilePond = vueFilePond(FilePondPluginFileValidateType)

import Dialog from 'primevue/dialog';
import Checkbox from 'primevue/checkbox';
import InputMask from 'primevue/inputmask';

import FileUpload from 'primevue/fileupload';
import ScrollPanel from 'primevue/scrollpanel';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';

/* Busca */
import MultiSelect from 'primevue/multiselect';
import Select from 'primevue/select';
import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import DatePicker from 'primevue/datepicker';

import Arquivo from '@/service/arquivo.js';
import Upload from '@/service/upload.js';
import Layout from '@/service/layout.js';
import Solicitante from '@/service/solicitante.js';

import ClienteListaSelect from '@/page/cliente/ListaSelect.vue';

import Token from '@/utils/Token';
import File from '@/utils/File';
import Filter from '@/utils/Filter.js';

import Moment from 'moment';

export default {
    components: {
        Dialog,
        InputGroup,
        InputGroupAddon,
        ScrollPanel,
        FloatLabel,
        InputText,
        Checkbox,
        Select,
        InputMask,

        Fieldset,
        FilePond,
        ProgressSpinner,
        BlockUI,
        
        Toolbar,
        Button,
        DataTable,
        Paginator,
        Column,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,
        MultiSelect,
        Select,
        DatePicker,

        ClienteListaSelect,
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {}
        },
        permissoes: {},
    },
    emits: ['save','close'],
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,
            visibleClienteListaSelect: false,

            files: [],
            isLoadingFile: false,

            expandedRows: [],

            layoutOpt: [],
            isLoadingLayoutOpt: false,

            solicitanteOpt: [],
            isLoadingSolicitanteOpt: false,

            /* Table */
            lista: [],
            item: {},
            visibleForm: false,

            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: -1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },

            STATUS: constantes.UPLOAD,
        }
    },
    mounted() {
        this.loadLayoutOpt();
        this.loadSolicitanteOpt();
    },
    methods: {
        onFileUpdate(files) {
            this.files = files.map(file => file.file)
        },
        openFileDialog() {
            this.$refs.pond.browse()
        },
        clearFileDialog() {
            this.files = []
        },
        async handleUpload() {
            this.errors = {}

            if (this.files.length === 0) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Nenhum arquivo selecionado',
                    life: 5000
                })
                return
            }

            this.isLoadingFile = true

            const formData = new FormData()
            for(let i in this.form) {
                formData.append(i, this.form[i]);
            }
            this.files.forEach(file => {
                formData.append('arquivo', file)
            })

            try {
                const response = await Arquivo.upload(formData)

                this.files = []
                this.form = {}

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: 'Arquivo enviado com sucesso. O processamento ocorrerá em segundo plano.',
                    life: 8000
                })

                this.$emit('save')
            } catch (error) {
                if (error.response?.data?.erros) {
                    for(let i in error.response.data.erros) {
                        this.errors[i]= error.response.data.erros[i][0]
                    }
                } else if (error.response?.data?.msg) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: error.response.data.msg,
                        life: 10000
                    })
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Erro ao realizar upload',
                        life: 5000
                    })
                }
            } finally {
                this.isLoadingFile = false
            }
        },

        showDataFields(form) {
            return (form.layout_id == 3 || form.layout_id == 6);
        },
        handleError(erro) {
            if(!erro) return;
            return erro.replace("\n", "<br />");
        },
        selectCliente(cliente) {
            this.form.cliente       = null;
            this.form.cliente_id    = null;

            if(cliente) {
                this.form.cliente       = cliente.nome;
                this.form.cliente_id    = cliente.id;
            }
        },
        clearCliente() {
            this.form.cliente       = null;
            this.form.cliente_id    = null;
        },
        dateFormat(value) {
            if (!value) return;
            return Moment(value).format("DD/MM/YYYY HH:mm");
        },
        
        download(data) {
            Arquivo.view(data.id)
                .then(response => {
                    File.download(response);
                });
        },
        onShow() {
            this.loadData();
        },
        onHide() {
            this.form = {};
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        onSubmit(form) {
            console.log("loadData");
        },
        loadSolicitanteOpt() {
            this.isLoadingSolicitanteOpt = true;
            Solicitante.option(['order[descricao]=asc'].join("&"))
                .then(response => {
                    this.solicitanteOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingSolicitanteOpt = false;
                });
        },
        loadLayoutOpt() {
            this.isLoadingLayoutOpt = true;
            Layout.option(['order[descricao]=asc'].join("&"))
                .then(response => {
                    this.layoutOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingLayoutOpt = false;
                });
        },

        loadDataParams() {
            let params = [];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Order
            params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            return params;
        },
        loadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Upload.list(params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        // Filter
        toggleBusca(event) {
            this.$refs.busca.toggle(event);
        },
        onClearBusca(event) {
            this.toggleBusca(event);
            this.params.filter = {};
            this.onPage();
        },
        onSubmitBusca(event) {
            this.toggleBusca(event);
            this.onPage();
        },

        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.loadData();
        },

        // Sort
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        },

        remove(item) {
            this.$confirm.require({
                message: 'Deseja realmente remover o item?',
                header: 'Remover',
                acceptLabel: 'Remover',
                icon: 'pi pi-trash',
                acceptClass: 'bg-red-500 text-white border-red-500',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Arquivo.delete(item.arquivo_id)
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi removido com sucesso.', life: 3000 });
                            this.loadData();
                        })
                        .catch(error => {
                            if (error.response) {
                                let err = error.response.data;
                                if (err.erros) {
                                    for (let i in err.erros) {
                                        this.errors[i] = err.erros[i][0];
                                    }
                                    return;
                                }
                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
    },
}
</script>

<style>
    .text-block {
        white-space: pre-line;
    }
</style>
